/* eslint-disable */
/**
 * Redirect the plural form of `orders` to `order`
 * @export
 */
export const ORDER_CONCRETE_DELIVERIES_PLURAL_PAGE_REDIRECT = `/orders/:orderId/concrete-deliveries`;

/**
 * The path of the `OrderConcreteDeliveriesPage` to be consumed by a `<Router />`
 * @export
 */
export const ORDER_CONCRETE_DELIVERIES_PAGE_PATH = `/order/:orderId/concrete-deliveries`;

/**
 * Create a `href` that will resolve to `OrderConcreteDeliveriesPage`
 * @export
 * @param {{ orderId: string }} params The dynamic params that need to be matched
 * @returns {string} The `ORDER_CONCRETE_DELIVERIES_PAGE_PATH`
 */
export const createOrderConcreteDeliveriesPageLink = ({ orderId }) => `/order/${orderId}/concrete-deliveries`;

/**
 * Determine if the current page is the `OrderConcreteDeliveriesPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `OrderConcreteDeliveriesPage`
 */
export const isOrderConcreteDeliveriesPage = (match) => match.path === ORDER_CONCRETE_DELIVERIES_PAGE_PATH;
